import { createComponent as _$createComponent } from "solid-js/web";
import { render } from "solid-js/web";
import { App } from "./App";
const container = document.getElementById("app");
if (container) {
  container.innerHTML = "";
  render(() => _$createComponent(App, {}), container);
} else {
  console.error("WorldView: #app container not found");
}